'use client';

import * as React from 'react';
import DeletePermissionModalContent from '@/app/dashboard/staff-settings/permissions/components/delete-permission-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function DeletePermissionModal(): React.JSX.Element | null {
  const { modal } = useAppSelector(getUi);

  if (!modal?.content) return null;

  return (
    <ModalLayout title="Delete Permission" isOpen={modal?.open === ModalDrawer.DELETE_PERMISSION}>
      <DeletePermissionModalContent />
    </ModalLayout>
  );
}
